module.exports = __webpack_public_path__ + "img/latex.8b133b88.jpg";